export default __webpack_public_path__ + "static/media/Renewableenergy.712c63fd.jpg";